import { all, AllEffect, ForkEffect, StrictEffect, put, call, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import BffApiService from '@/shared/bffApiService';

import { BffCmsFaqResponse, BffResponse } from '@lucky7ventures/bff-types';
import { FaqActionType, getFaqError, getFaqSuccess } from '@/store/cms/faq/actions';

export function* getFaqSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffCmsFaqResponse>>
> {
  try {
    const response = yield call(BffApiService.getFaq);

    if (response.data.data) {
      yield put(getFaqSuccess(response.data.data));
    }
  } catch (error) {
    yield put(getFaqError());
  }
}

export function* watchFaqSagas(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(FaqActionType.GetFaq, getFaqSaga)]);
}
